import { IForm } from 'core-components/classes/models/IForm'
import { BaseCrud, Static } from 'core-components/types'

import { TTableProps } from '../types'

interface IGetSourceArgs<P, R> {
  source: TTableProps<P, R>['source']
  items: TTableProps<P, R>['items']
  pageSize: TTableProps<P, R>['pageSize']
  keyField: TTableProps<P, R>['keyField']
}

export const getSource = <P = IForm, R = string | number>(props: IGetSourceArgs<P, R>) => {
  if (props.source) {
    return props.source
  }
  const crud = new BaseCrud<P, R>({
    fetcher: new Static<P, R>(props.items || []),
    keyField: getKeyField(props),
  })
  crud.setPaging({
    page: 0,
    pageSize: props.pageSize || 20,
  })
  return crud
}

interface IGetKeyField<P, R> {
  source: TTableProps<P, R>['source']
  keyField: TTableProps<P, R>['keyField']
}

export const getKeyField = <P, R>(props: IGetKeyField<P, R>) => {
  return props.source?.keyField || props.keyField || 'EntryId'
}
